import { Box, Typography } from '@mui/material';
import { vehicleFormHooks } from 'app-components/flux/vehicle/vehicleForm';
import { tracker } from 'app-components/utils/core';
import QButton from 'components/QButton';
import QIllustration from 'components/QIllustration';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  addedContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  dismissButton: {
    margin: theme.spacing(3, 4),
    padding: theme.spacing(1, 7),
    borderRadius: theme.spacing(4),
  },
  carIllustration: {
    marginTop: theme.spacing(-1),
  },
}));
type AddedStep = {
  handleDialogClose: () => void;
  isManual: boolean;
};

export const AddedStep = (props: AddedStep) => {
  const { classes } = useStyles();

  const { handleDialogClose, isManual } = props;
  const { value: accountName } = vehicleFormHooks.useField('name');
  const { value: linkTo } = vehicleFormHooks.useField('linkTo');

  return (
    <Box className={classes.addedContainer}>
      <QIllustration name='CarAdded' size='xl' className={classes.carIllustration} />
      <Box px={4}>
        <Typography variant='bodyMedium' textAlign='center'>
          {`${accountName}`}
        </Typography>
        <Typography variant='bodyRegular' textAlign='center'>
          {linkTo !== '0'
            ? 'has been updated, and will be linked to updates from Kelley Blue Book.'
            : isManual
              ? 'has been added to your accounts bar.'
              : 'has been added to your accounts bar, and will be linked to updates from Kelley Blue Book.'}
        </Typography>
      </Box>
      <QButton
        variant='contained'
        onClick={() => {
          handleDialogClose();
          tracker.track(tracker.events.kbbFinish);
        }}
        className={classes.dismissButton}
      >
        Dismiss
      </QButton>
    </Box>
  );
};
